import isArray from 'lodash/isArray';

import { updateThumbnail } from 'common/api/thumbnails';

import {
    UPLOAD_THUMBNAIL,
    UPLOAD_THUMBNAIL_FAILURE,
    UPLOAD_THUMBNAIL_SUCCESS,
} from '../actionTypes';
import { productThumbnailActions } from '../reducer';

export default (values, productId) => (dispatch) =>
    new Promise((resolve) => {
        let data = new FormData();

        if (isArray(values.image_thumbnail)) {
            data.append(
                'image',
                values.image_thumbnail && values.image_thumbnail[0],
            );
        }

        dispatch(productThumbnailActions[UPLOAD_THUMBNAIL]());

        updateThumbnail(data, productId)
            .then((response) => {
                dispatch(
                    productThumbnailActions[UPLOAD_THUMBNAIL_SUCCESS](
                        response.data,
                    ),
                );
            })
            .catch((error) => {
                dispatch(
                    productThumbnailActions[UPLOAD_THUMBNAIL_FAILURE](
                        error.response.data.errors,
                    ),
                );
            })
            .finally(resolve);
    });
